export default "__VITE_ASSET__189b06d9__"